export { default as PagesProductPage } from './ui/PagesProductPage';
